import { useMutation, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { governanceApi } from 'src/Services/API';
import { UpdateOwnerGovernanceDto } from 'src/types/governance.types';

export const useUpdateOwnerGovernance = () => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation(
    (data: UpdateOwnerGovernanceDto) => governanceApi.updateOwnerGovernance(assetId!, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch-members', assetId]);
        queryClient.invalidateQueries(['fetch-asset-details', assetId]);
      },
    }
  );
};
